import React, {useMemo} from 'react'
import {Grid, makeStyles} from '@material-ui/core'
import './styles.css'
import {formatNumberInput, formatNumberInputNotDecimal, formatPersonInput} from "./ScenarioRenderType";

const useStyles = makeStyles({
  contentInputScenario: {
    padding: '12px',
    float: 'left',
    width: '50%',
  },
  titleInputScenario: {
    color: '#8D9CB1',
    fontSize: '12px',
    fontHeight: '18x',
    fontWeight: 500
  },
  titleValueNew: {
    color: '#181818',
    fontSize: '12px',
    fontHeight: '18x',
    fontWeight: 600
  },
  titleValueSlider: {
    // color: '#181818',
    fontSize: '12px',
    fontHeight: '18x',
    fontWeight: 600
  },
  divSliderContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }
})

const ScenarioShowValue = ({
  title = 'Short term Debt',
  attribute,
  dataValueChange1
}) => {
  const classes = useStyles()

  const newValue = useMemo(() => {
    let val = dataValueChange1?.find((it) => it?.attribute === attribute)
    if(val?.newValue) {
      return val?.newValue
    }
    return 0
  }, [dataValueChange1])

  const valueSlider = useMemo(() => {
    let val = dataValueChange1?.find((it) => it?.attribute === attribute)
    if(val?.valSlider) {
      return val?.valSlider
    }
    return 0
  }, [dataValueChange1])


  return (
      <div className={classes.contentInputScenario}>
        <div style={{paddingRight: 10, fontSize: 14}}>
          <span className={classes.titleInputScenario}>{title}</span>
        </div>
        <Grid container className={classes.divSliderContent}>
          <Grid item xs={5} sm={5}>
            <span className={classes.titleValueNew}>{formatNumberInputNotDecimal(newValue, attribute)}</span>
          </Grid>
          <Grid item xs={5} sm={5} >
            {valueSlider !== 0 &&
                <span className={classes.titleValueSlider}>{formatPersonInput(valueSlider)}</span>}
          </Grid>
        </Grid>
      </div>
  )
}

export default React.memo(ScenarioShowValue)
